export default __webpack_public_path__ + "static/media/159.35272c2f.jpg";